import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import { getHeroes } from '../services/api';
import './About.css';

const About = () => {
  const [hero, setHero] = useState(null);

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const data = await getHeroes();
        setHero(data.about);
      } catch (error) {
        console.error('Error fetching hero:', error);
      }
    };
    fetchHero();
  }, []);

  return (
    <div className="about-page">
      <Hero
        title="About SVT Consulting"
        subtitle="Your trusted partner for professional technology solutions"
        backgroundImage={hero?.image_url}
        ctaText="Contact Us"
        ctaLink="/contact"
        height="medium"
        overlay={0.7}
      />

      <section className="section">
        <div className="container">
          <div className="about-intro">
            <div className="intro-content">
              <h2>Who We Are</h2>
              <p>
                SVT Consulting is a full-service technology company specializing in 
                audio/video systems, security solutions, smart home automation, and 
                custom software development. Based in New Jersey, we serve residential 
                and commercial clients throughout the tri-state area.
              </p>
              <p>
                Our team of certified professionals brings years of experience and a 
                passion for technology to every project. We pride ourselves on delivering 
                solutions that not only meet but exceed our clients' expectations.
              </p>
            </div>
            <div className="intro-image">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600" alt="Our Team" />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-gray">
        <div className="container">
          <div className="section-title">
            <h2>Our Values</h2>
            <p>The principles that guide everything we do</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Quality</h3>
              <p>We never compromise on quality. Every installation and every line of code meets our rigorous standards.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Integrity</h3>
              <p>Honest communication, transparent pricing, and reliable service are the foundation of our business.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">💡</div>
              <h3>Innovation</h3>
              <p>We stay ahead of technology trends to bring you the latest and most effective solutions.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">❤️</div>
              <h3>Customer Focus</h3>
              <p>Your satisfaction is our priority. We listen, understand, and deliver solutions tailored to your needs.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="certifications">
            <h2>Certifications & Partnerships</h2>
            <p>We're proud to be certified by leading brands in the industry</p>
            <div className="cert-logos">
              <div className="cert-item">Control4</div>
              <div className="cert-item">Sonos</div>
              <div className="cert-item">Lutron</div>
              <div className="cert-item">Hikvision</div>
              <div className="cert-item">Sony</div>
              <div className="cert-item">Samsung</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
